export enum ControlType {
    SingleLineText = "SingleLineText",
    MultiLineText = "MultiLineText",
    Select = "Select",
    Checkbox = "Checkbox",
    Sensitive = "Sensitive",
    StepName = "StepName",
    AzureAccount = "AzureAccount",
    Certificate = "Certificate",
    AmazonWebServicesAccount = "AmazonWebServicesAccount"
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/controlType.ts